





































































import { Component, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

import Super from './Super';
import { trackAction, TrackingAction } from './lib/tracking';
import { State } from './vuex-decorators';

import Header from '@/components/Header.vue';
import Sidebar from '@/components/Sidebar.vue';
import Modal from '@/components/Modal.vue';

import RequestMeetingModal from '@/components/modals/RequestMeetingModal.vue';
import MedicalInformationModal from '@/components/modals/MedicalInformationModal.vue';
import PDFModal from '@/components/modals/PDFModal.vue';
import WebModal from '@/components/modals/WebModal.vue';
import VideoModal from '@/components/modals/VideoModal.vue';
import ResourceListModal from '@/components/modals/ResourceListModal.vue';

@Component<App>({
  components: {
    Header,
    Sidebar,
    Modal,
    RequestMeetingModal,
    MedicalInformationModal,
    PDFModal,
    WebModal,
    VideoModal,
    ResourceListModal
  }
})
export default class App extends Super {
  @State((v: boolean) => trackAction(`Request meeting ${v ? 'opened' : 'closed'}`, TrackingAction.MODAL))
  viewingRequestMeeting!: boolean;

  @State((v: boolean) => trackAction(`Medical information ${v ? 'opened' : 'closed'}`, TrackingAction.MODAL))
  viewingMedicalInformation!: boolean;

  @State<App>(function(v: boolean) { trackAction(`PDF ${v ? 'opened' : 'closed'}: ${this.pdfTitle}`, TrackingAction.RESOURCE) })
  viewingPDF!: boolean;

  @State<App>(function(v: boolean) { trackAction(`Iframe ${v ? 'opened' : 'closed'}: ${this.webTitle}`, TrackingAction.RESOURCE) })
  viewingWeb!: boolean;

  @State<App>(function(v: boolean) { trackAction(`Iframe ${v ? 'opened' : 'closed'}: ${this.webTitle}`, TrackingAction.RESOURCE) })
  viewingLargeWeb!: boolean;

  @State<App>(function(v: boolean) { trackAction(`Video ${v ? 'opened' : 'closed'}: ${this.videoTitle}`, TrackingAction.RESOURCE) })
  viewingVideo!: boolean;

  @State<App>(function(v: boolean) { trackAction(`Resource list ${v ? 'opened' : 'closed'}: ${this.currentResourceListTitle}`, TrackingAction.MODAL) })
  viewingResourceList!: boolean;
  
  @State() pdfTitle!: string;
  @State() pdfURL!: string;

  @State() webTitle!: string;
  @State() webURL!: string;

  @State() videoTitle!: string;
  @State() videoURL!: string;

  @State() currentResourceList!: string;
  @State() currentResourceListTitle!: string;

  @Watch('$route')
  handleRouteChange(newRoute: Route, oldRoute: Route) {
    trackAction(`${oldRoute.path} => ${newRoute.path}`, TrackingAction.NAVIGATION);
  }
  created() {
    trackAction("homepage view",TrackingAction.NAVIGATION);
  }
  openSunovionResources() {
    this.openWeb('Sunovion Product Resources', 'https://www.sunovionprofile.com/latuda-bpd/');
  }
}
